import { ScatterPlotRawSerie } from '@nivo/scatterplot';
import { useState } from 'react';

export enum NodeType {
    UP_ARROW = 'UP_ARROW',
    DOWN_ARROW = 'DOWN_ARROW',
    NORMAL = 'NORMAL',
    EMPTY_NODE = 'EMPTY_NODE'
}

const CustomNodes = [NodeType.DOWN_ARROW, NodeType.UP_ARROW, NodeType.EMPTY_NODE];

export const useScatterPlotGraph = ({ plotData = [], maxYLabels = 4 }: { plotData: ScatterPlotRawSerie<any>[]; maxYLabels?: number }) => {
    const [range, setRange] = useState<{ min: number; max: number }>({ min: 0, max: maxYLabels });
    const yLabels = Array.from(new Set(plotData?.[0]?.data?.filter(d => !CustomNodes.includes(d?.nodeType)).map(d => d.y)));
    const displayableYLabels = yLabels.slice(range.min, range.max);
    const total = yLabels?.length;
    const data =
        plotData?.[0]?.data?.filter(d => {
            if (CustomNodes.includes(d.nodeType)) {
                return true;
            }
            return displayableYLabels.includes(d.y);
        }) ?? [];

    const moveUp = () => {
        if (range.min > 0) {
            setRange({ max: range.max - 1, min: range.min - 1 });
        }
    };
    const moveDown = () => {
        if (range.max < yLabels.length) {
            setRange({ max: range.max + 1, min: range.min + 1 });
        }
    };

    return {
        disableUp: range.min === 0,
        disableDown: range.max === yLabels.length,
        moveUp,
        moveDown,
        range,
        total,
        data: data.length
            ? [
                  {
                      ...plotData[0],
                      data
                  }
              ]
            : []
    };
};
